// @noflow
import { getDownloadedContentBySlug, getDownloadedContent } from 'Common/downloads/utils';
import { getJson } from '../utilities/fetchUtils';
import isReactNative from '../app/isReactNative';
import deviceType from '../app/getDeviceType';

export const setRequireRefresh = (require: boolean) => ({ dispatch }) => {
  if (require) {
    return dispatch({ type: 'SET_REQUIRE_FRANCHISE_REFRESH' });
  }
  return dispatch({ type: 'UNSET_REQUIRE_FRANCHISE_REFRESH' });
};

export const setRecentlyWatchedContentId = contentId => ({ dispatch }) => {
  dispatch({
    type: 'SET_RECENTLY_WATCHED_CONTENT_ID',
    contentId,
  });
};

export const setFranchiseProgress = (progressPercentage, progressSeconds) => ({
  getState,
  dispatch,
}) => {
  const state = getState();
  const {
    player: { contentId, programInfo },
  } = state;
  const programContentId = contentId || programInfo?.content_id;

  dispatch({
    type: 'SET_FRANCHISE_PROGRESS',
    payload: { [programContentId]: { progressPercentage, progressSeconds } },
  });
};

export const fetchRecommendations = (echoStar3id, callback) => ({ getState, dispatch, config }) => {
  const state = getState();

  dispatch({
    type: 'REQUEST_RECOMMENDATIONS',
  });

  const url = `${
    config.session.radish_url
  }/v20/dol/recommendations/${echoStar3id}/index?total_items=12`;
  return getJson({ url, state })
    .then(payload => {
      dispatch({
        type: 'RECEIVE_RECOMMENDATIONS',
        payload,
      });
      if (callback) {
        callback(payload);
      }
    })
    .catch(error => {
      console.warn('fetch error', error);
      dispatch({ type: 'REQUEST_RECOMMENDATIONS_ERROR' });
    });
};

export const fetchFranchise = (
  slug,
  caching = { timeout: 0 },
  requestRecommendations = true,
  isFullRequest = false,
) => ({ getState, dispatch, config }) => {
  const state = getState();
  const useFastDownload = isReactNative && deviceType !== 'Tv';

  // The pre-fetching request works only for mobile and use for speeding up
  // heavy fetch requests (etc. many seasons/dvr/episodes) by running light/heavy request one by one.
  // The version 2 is the light variation of same request.
  // It works only for 'shows' and returns season/dvr/episodes records only for LAST season.
  // In case of 'movie' the version 2 works similar to version 1.
  const version = useFastDownload && !isFullRequest ? 2 : 1;
  const headers = {
    Accept: `application/vnd.echostar.franchise+json;version=${version}`,
  };

  dispatch({
    type: 'REQUEST_FRANCHISE',
    slug,
    requestRecommendations,
    isFullRequest,
  });

  if (state.networkInfo && !state.networkInfo.isInternetReachable) {
    const franchise = getDownloadedContentBySlug(
      slug,
      getDownloadedContent(state.downloads?.list.content),
    );

    if (franchise) {
      return dispatch({
        type: 'RECEIVE_FRANCHISE',
        slug,
        payload: franchise,
      });
    }
  }

  if (state.franchise.franchiseDetails.requireRefresh) {
    caching = { timeout: 0 };
  }

  const url = `${config.session.radish_url}franchise/${slug}`;

  return (
    getJson({ url, headers, state, caching })
      .then(payload => {
        if (payload.error) {
          throw new Error('No slug found on server!');
        }
        if (requestRecommendations) {
          dispatch(fetchRecommendations(payload.echostar3_id));
        }
        dispatch({
          type: 'RECEIVE_FRANCHISE',
          slug,
          payload,
        });
        return payload;
      })
      // eslint-disable-next-line no-unused-vars
      .then(payload => {
        dispatch(setRequireRefresh(false));
        if (useFastDownload && !isFullRequest && payload.kind === 'show') {
          // the pre-fetching works only for 'shows', no need to fetch one more time for 'movie'
          dispatch(fetchFranchise(slug, { timeout: 0 }, false, true));
        }
        return payload;
      })
      .catch(error => {
        console.warn('fetch error', error);
        dispatch({ type: 'REQUEST_FRANCHISE_ERROR', slug });
      })
  );
};
